import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import PieGraph from "../../../general/PieGraph";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./HealthL3.module.css";
import { HealthStore } from "./HealthStore";

function HealthL3({ distrito }) {
  const [possuiDoencaCronica, setPossuiDoencaCronica] = useState(null);
  const [tipoDoencaCronica, setTipoDoencaCronica] = useState(null);
  const [programaSaudeRural, setProgramaSaudeRural] = useState(null);
  const [possuiDoencaCronicaOldValue, setPossuiDoencaCronicaOldValue] =
    useState(null);
  const [tipoDoencaCronicaOldValue, setTipoDoencaCronicaOldValue] =
    useState(null);
  const [programaSaudeRuralOldValue, setProgramaSaudeRuralOldValue] =
    useState(null);

  const setPossuiDoencaCronicaValue = HealthStore(
    (state) => state.setPossuiDoencaCronicaValue
  );

  const setTipoDoencaCronicaValue = HealthStore(
    (state) => state.setTipoDoencaCronicaValue
  );

  const setProgramaSaudeRuralValue = HealthStore(
    (state) => state.setProgramaSaudeRuralValue
  );

  const setPossuiDoencaCronicaImage = HealthStore(
    (state) => state.setPossuiDoencaCronicaImage
  );

  const setTipoDoencaCronicaImage = HealthStore(
    (state) => state.setTipoDoencaCronicaImage
  );

  const setProgramaSaudeRuralImage = HealthStore(
    (state) => state.setProgramaSaudeRuralImage
  );

  const frequenciaExameValue = HealthStore(
    (state) => state.frequenciaExameValue
  );

  const atendimentoAmbulanciaValue = HealthStore(
    (state) => state.atendimentoAmbulanciaValue
  );

  const sistemaSaudeValue = HealthStore((state) => state.sistemaSaudeValue);

  const usoMedicamentoValue = HealthStore((state) => state.usoMedicamentoValue);

  const dificuldadeAtendimentoValue = HealthStore(
    (state) => state.dificuldadeAtendimentoValue
  );

  const possuiDoencaCronicaValue = HealthStore(
    (state) => state.possuiDoencaCronicaValue
  );

  const tipoDoencaCronicaValue = HealthStore(
    (state) => state.tipoDoencaCronicaValue
  );

  const programaSaudeRuralValue = HealthStore(
    (state) => state.programaSaudeRuralValue
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [possuiDoencaCronica, tipoDoencaCronica, programaSaudeRural] =
          await Promise.all([
            Api.getPossuiDoencasCronicas(
              distrito,
              frequenciaExameValue,
              atendimentoAmbulanciaValue,
              sistemaSaudeValue,
              usoMedicamentoValue,
              dificuldadeAtendimentoValue,
              null,
              tipoDoencaCronicaValue,
              programaSaudeRuralValue
            ),
            Api.getTipoDoencasCronicas(
              distrito,
              frequenciaExameValue,
              atendimentoAmbulanciaValue,
              sistemaSaudeValue,
              usoMedicamentoValue,
              dificuldadeAtendimentoValue,
              possuiDoencaCronicaValue,
              null,
              programaSaudeRuralValue
            ),
            Api.getProgramaSaudeRural(
              distrito,
              frequenciaExameValue,
              atendimentoAmbulanciaValue,
              sistemaSaudeValue,
              usoMedicamentoValue,
              dificuldadeAtendimentoValue,
              possuiDoencaCronicaValue,
              tipoDoencaCronicaValue,
              null
            ),
          ]);
        setPossuiDoencaCronica(
          Functions.buildSmallPieGraphParams(possuiDoencaCronica)
        );
        setTipoDoencaCronica(Functions.buildPieGraphParams2(tipoDoencaCronica));
        setProgramaSaudeRural(
          Functions.buildSmallPieGraphParams(programaSaudeRural)
        );
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };

    fetchData();
  }, [
    distrito,
    frequenciaExameValue,
    atendimentoAmbulanciaValue,
    sistemaSaudeValue,
    usoMedicamentoValue,
    dificuldadeAtendimentoValue,
    possuiDoencaCronicaValue,
    tipoDoencaCronicaValue,
    programaSaudeRuralValue,
  ]);

  const onPossuiDoencaCronicaClick = (value) => {
    setPossuiDoencaCronicaValue(value);
  };

  const onTipoDoencaCronicaClick = (value) => {
    setTipoDoencaCronicaValue(value);
  };

  const onProgramaSaudeRuralClick = (value) => {
    setProgramaSaudeRuralValue(value);
  };

  const onPossuiDoencaCronicaOldValue = (value) => {
    setPossuiDoencaCronicaOldValue(value);
  };

  const onTipoDoencaCronicaOldValue = (value) => {
    setTipoDoencaCronicaOldValue(value);
  };

  const onProgramaSaudeRuralOldValue = (value) => {
    setProgramaSaudeRuralOldValue(value);
  };

  return (
    <div className={styles.generalConditionL1}>
      {possuiDoencaCronica && (
        <div className={styles.smallPiegraph}>
          <SmallPieGraph
            data={possuiDoencaCronica}
            text="POSSUI DOENÇA CRÔNICA"
            onLegendClick={onPossuiDoencaCronicaClick}
            currentValue={possuiDoencaCronicaValue}
            oldValue={possuiDoencaCronicaOldValue}
            onOldValue={onPossuiDoencaCronicaOldValue}
            onImageReady={setPossuiDoencaCronicaImage}
          />
        </div>
      )}

      {tipoDoencaCronica && (
        <div className={styles.smallPiegraph}>
          <PieGraph
            data={tipoDoencaCronica}
            text="TIPO DE DOENÇA"
            onLegendClick={onTipoDoencaCronicaClick}
            currentValue={tipoDoencaCronicaValue}
            oldValue={tipoDoencaCronicaOldValue}
            onOldValue={onTipoDoencaCronicaOldValue}
            onImageReady={setTipoDoencaCronicaImage}
          />
        </div>
      )}

      {programaSaudeRural && (
        <div className={styles.smallPiegraph}>
          <SmallPieGraph
            data={programaSaudeRural}
            text="PROGRAMA DE SAÚDE RURAL"
            onLegendClick={onProgramaSaudeRuralClick}
            currentValue={programaSaudeRuralValue}
            oldValue={programaSaudeRuralOldValue}
            onOldValue={onProgramaSaudeRuralOldValue}
            onImageReady={setProgramaSaudeRuralImage}
          />
        </div>
      )}
    </div>
  );
}

export default HealthL3;
